import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./lang/index";
import globalRegist from "./globalRegist";
import "lib-flexible/flexible";
import FastClick from 'fastclick';
import VConsole from 'vconsole';
import 'vant/lib/index.less';
import projectConfig from '@/utils/global_val';
//import 'dsbridge';
import config from './config/config'
import sensors from './utils/sensors.js';
import '@/assets/fonts/index.css'
import { Lazyload } from 'vant';
import { setRouteQuery } from './utils/util';
import '@/assets/theme.less';


Vue.use(globalRegist);
Vue.use(Lazyload);

Vue.config.productionTip = false;
Vue.prototype.$APP_CONFIG = Object.assign(config, window.APP_CONFIG);
Vue.prototype.$projectConfig = projectConfig;
Vue.prototype.$sensors = sensors;
Vue.prototype.$setRouteQuery = setRouteQuery;

router.beforeEach((to, from, next) => {
  // 初始化vconsole
  let is_vconsole = localStorage.getItem('vconsole');
  if(is_vconsole && is_vconsole === 'true') {
      const vConsole = new VConsole();
      Vue.use(vConsole);
  }

  if(to.meta.title) {
      document.title = to.meta.title
  }

  sensors.registerPage({
    $title: to?.meta?.pageTitle || '流量商城' // 手动设置标题
  })

  next();  
  
});


router.afterEach((to) => {
  sensors.track('$pageview', {
    $title: to?.meta?.pageTitle || '流量商城' // 手动设置标题
  });
});

FastClick.attach(document.body);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
